import { MATRIX_CELL_WIDTH, MATRIX_SEPARATOR_WIDTH } from '@/constants';

const DEFAULT_MATRIX_ROWS = [
  [
    {
      cells: [
        { type: 'cell', width: MATRIX_CELL_WIDTH, children: [] },
        { type: 'cell', width: MATRIX_CELL_WIDTH, children: [] },
        { type: 'cell', width: MATRIX_CELL_WIDTH, children: [] },
        { type: 'cell', width: MATRIX_CELL_WIDTH, children: [] },
        { type: 'cell', width: MATRIX_CELL_WIDTH, children: [] },
      ],
    },
  ],
];

export default () => {
  const isMatrixFixedCellWidth = false;
  const isMatrixSeparator = false;
  const isMatrixBordersEnabled = false;
  const matrixCellWidth = MATRIX_CELL_WIDTH;
  const matrixSeparatorWidth = MATRIX_SEPARATOR_WIDTH;
  const matrixRows = DEFAULT_MATRIX_ROWS.reduce((acc, row) => {
    return [...acc, ...row];
  }, []);
  const matrices = [];

  return {
    isMatrixFixedCellWidth,
    isMatrixSeparator,
    isMatrixBordersEnabled,
    matrixCellWidth,
    matrixSeparatorWidth,
    matrixRows,
    matrices,
  };
};
